import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import './styles.css';

import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import ativo from '../../assets/images/ativo.png';
import naoAtivo from '../../assets/images/naoativo.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

const CursosEventos = () => {

  const [courses, setCourses] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [load, setLoad] = useState(false);

  const alert = useAlert();

  const getCourses = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/course', { params: { search } });
      setCourses(resources.data);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error.response);
    }
  }


  useEffect(() => {
    getCourses();
  }, []);

  const handleStatus = async id => {
    try {
      const { data: { resources }
      } = await api.post(`admin/course/${id}/status`);
      setCourses(resources.data);
    } catch (error) {
      console.log(error);
    }
  }
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }
  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/course/${idDelete}`);
      setCourses(resources.data);
      alert.show("Dados removidos com sucesso!");
    } catch (error) {
      console.log(error);
    }
    setShow(false);
  }
  const handleSearch = (e) => {
    const value = e.target.value;
    setLoad(true);
    setSearchString(value);
    getCourses(value);
  }

  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">
      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Cursos e Eventos</h5>
              <Link to="/cursos-e-eventos/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {load &&
              <div className="load-table">
                <div className="loading"></div>
              </div>
            }
            <Table responsive>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Horário</th>
                  <th className="tableLeft">Título</th>
                  <th>Ativo</th>
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {courses.map((course, key) => (
                  <tr key={key}>
                    <td>{course.date}</td>
                    <td>{course.hour}</td>
                    <td className="tableLeft">{course.title}</td>
                    <td><img className="imgActive" src={course.status === 1 ? ativo : naoAtivo} alt="Icon" onClick={() => handleStatus(course.id)} />{course.status === 1 ? 'Sim' : 'Não'}</td>
                    <td>
                      <Link to={`/cursos-e-eventos/edit/${course.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} alt="Icon" onClick={() => handleDelete(course.id)} /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default CursosEventos;